import React from 'react';

const SOCIAL = {
  whatsapp: 'https://wa.me/917889944522',
  facebook:
    'https://www.facebook.com/people/Dynamic-Delby-Nowgam/61572374666342/?rdid=cAjjZTgoJPkGZO84&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D22jfgesk%2F%3Fref%3D1',
  instagram:
    'https://www.instagram.com/dynamic_nowgam?utm_source=qr&igsh=MXhqMmZvNWg2cXJkbA==',
  youtube: 'https://www.youtube.com/@delbydynamic',
};

function SocialLinks({ className = '' }) {
  return (
    <div className={className}>
      <a href={SOCIAL.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <i className="fab fa-whatsapp"></i>
      </a>
      <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
        <i className="fab fa-instagram"></i>
      </a>
      <a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
        <i className="fab fa-youtube"></i>
      </a>
    </div>
  );
}

export default SocialLinks;
